<template>
  <div>
    <div v-if="loading" class="dc-loading">
      <div class="bg-img-container">
        <div class="bg-img-1 active">
          <img class="Background" src="../../public/img/maison-1.png" />
        </div>
        <div class="bg-img-2">
          <img class="Background" src="../../public/img/maison-2.png" />
        </div>
        <div class="bg-img-3">
          <img class="Background" src="../../public/img/maison-3.png" />
        </div>
        <div class="bg-img-4">
          <img class="Background" src="../../public/img/maison-4.png" />
        </div>
        <div class="bg-img-5">
          <img class="Background" src="../../public/img/maison-5.png" />
        </div>
        <div class="bg-img-6">
          <img class="Background" src="../../public/img/maison-6.png" />
        </div>
        <div class="bg-img-7">
          <img class="Background" src="../../public/img/maison-7.png" />
        </div>
        <div class="bg-img-8">
          <img class="Background" src="../../public/img/maison-8.png" />
        </div>
      </div>
      <div class="data-container">
        <img class="logo" src="../assets/logo-loading.png" />
        <div class="loading-bar">
          <span>{{loaded}}</span>
          <div class="progress" :style="`width: ${loaded}`"></div>
        </div>
        <!-- <p>HOLDING THIS PAIN</p> -->
        <p>
          This might take a moment. <br />We're loading all files, music, and
          images.
        </p>
        <p>THIS IS A FAN PROJECT<br />CONTACT@DEUKAE.COM</p>
      </div>
      <div class="gradient"></div>
    </div>

    <div class="canvas-class"></div>

    <ion-phaser v-bind:game.prop="game" v-bind:initialize.prop="initialize">
    </ion-phaser>

    <div
      id="joystick-area"
      style="
        margin-bottom: 1px;
        margin-left: 14%;
        width: 20%;
        height: 40%;
        background-color: transparent;
        position: absolute;
        bottom: 0px;
      "
    ></div>
    <div
      style="
        font-family: CustomFont;
        position: absolute;
        left: -1000px;
        visibility: hidden;
      "
    >
      .
    </div>
  </div>
</template>

<script>
// import Phaser from "phaser";
// import Start from './scenes/game1/start';
import Game1 from "../scenes/init/game1";
import { EventBus } from "@/main";



export default {
  name: "GameView",
  data() {
    return {
      initialize: true,
      game: Game1,
      loading: true,
      loadingPercent: 0,
        loadTime: 0,
        interval: null
    };
  },
  beforeMount() {
    EventBus.$on("loading", () => {
      this.loading = false;
    });
  },
  methods: {
    initializeGame() {
      this.initialize = true;
      // this.centrarScroll();
    },
    doProgress() {
      let step = this.loadTime / 100;
      this.interval = setInterval(() => {
        this.loadingPercent++;
      }, step);
    },
    centrarScroll() {
    // Calcula la posición para centrar el scroll verticalmente
    const scrollVertical = (document.documentElement.scrollHeight - window.innerHeight) / 2;

    // Calcula la posición para centrar el scroll horizontalmente
    const scrollHorizontal = (document.documentElement.scrollWidth - window.innerWidth) / 2;

    // Realiza el scroll hacia la posición calculada
    window.scrollTo({
        top: scrollVertical,
        left: scrollHorizontal,
        behavior: 'smooth' // Scroll animado, puedes usar 'auto' para que sea instantáneo
    });
}


  },
  created() {
    let perfData = window.performance.timing;
    let estimatedTime = Math.abs(
      perfData.loadEventEnd - perfData.navigationStart
    );
    this.loadTime = parseInt((estimatedTime / 1000) % 60) * 100;
    this.doProgress();
  },
  computed: {
    loaded() {
      return this.loadingPercent + "%";
    },
  },
   watch: {
      loadingPercent(val) {
        if (val >= 100) {
          clearInterval(this.interval)
        }
      }
    },
};

document.addEventListener("DOMContentLoaded", () => {
  const images = document.querySelectorAll(".bg-img-container div");
  const totalImages = images.length;
  let loadedImages = 0;

  // Espera a que todas las imágenes se carguen
  images.forEach((div) => {
    const img = div.querySelector("img");
    img.onload = () => {
      loadedImages++;
      if (loadedImages === totalImages) {
        startAnimation();
      }
    };
    img.onerror = () => {
      console.error(`Error al cargar la imagen: ${img.src}`);
    };
  });

  function startAnimation() {
    let currentIndex = 0;
    let forward = true;

    setInterval(() => {
      images.forEach((div) => div.classList.remove("active"));

      images[currentIndex].classList.add("active");

      if (forward) {
        currentIndex++;
        if (currentIndex === totalImages - 1) {
          forward = false;
        }
      } else {
        currentIndex--;
        if (currentIndex === 0) {
          forward = true;
        }
      }
    }, 250);
  }
});



</script>

<style>

.canvas-class {
    width: 100%;
    height: 100vh;
    position: fixed;
    z-index: 0;
    touch-action: none; /* Previene zoom táctil */
    overscroll-behavior: none; /* Evita efectos de rebote */
}
•⁠  ⁠{
    user-select: none;
}
canvas {
  max-height: 100vh;
  max-height: -webkit-fill-available;
  max-width: 100vw;
  max-width: -webkit-fill-available;
  position: relative;
  z-index: 1;
}
body {
  margin: 0px;
  background-color: black;
  overflow: hidden;
  user-select: none;
}

.bg-img-container {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 2;
  overflow: hidden;
}

.bg-img-container div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.bg-img-container div img{
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.bg-img-container div.active {
  opacity: 1;
}


.loading-bar {
  width: 200px;
  height: 20px;
  border: 2px solid white;
  position: relative;
  margin: auto;
  margin-top: 20px;
}

.loading-bar span {
  font-family: "CustomFont";
  color: white;
  position: absolute;
  top: 0px;
  right: 4px;
  font-size: 21px;
}

.loading-bar .progress {
  height: 100%;
  transition: 0.3s;
  opacity: 0.2;
  background: white;
  animation: flashing forwards infinite 2s;
}

@keyframes flashing {
  0% {
    opacity: 0.2;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.2;
  }
}

.dc-loading {
  background: black;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  display: flex;
  align-items: end;
  justify-content: center;
  color: white;
  z-index: 2;
}

.data-container {
  position: relative;
  z-index: 3;
  text-align: center;
  padding-bottom: 40px;
}

.dc-loading .logo {
  width: 120px;
  /* background: rgba(0, 0, 0, 0.5); */
  border-radius: 9px;
  padding: 10px;
  position: fixed;
  left: 10px;
  top: 10px;
  /* animation: rotateY 3s linear infinite; */
}

.dc-loading p {
  color: white;
  font-family: "CustomFont";
  text-align: center;
  font-size: 46px;
  margin: 0px;
  margin-top: 20px;
  /* opacity: 0.6; */
}

.gradient {
  background: rgb(82, 0, 0);
  background: linear-gradient(
    0deg,
    rgba(82, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0.7) 44%,
    rgba(0, 212, 255, 0) 100%
  );
  width: 100%;
  height: 100%;
  position: fixed;
  bottom: 0px;
  z-index: 2;
}

@keyframes rotateY {
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(180deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}

/* .image-bg {
        background-image: url('./assets/table.png');
        width: 100%;
        height: 100%;
        position: relative;
        min-width: 100vw;
        min-height: 100vh;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    } */

.book {
  min-width: 900px;
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -45%);
  /* animation: bookAnimation 3s infinite; */
  z-index: 3;
  max-width: 1280px;
}

.book-container {
  display: block;
  height: 100vh;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.paper {
  min-width: 1300px;
  max-width: 2200px;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -45%);
}

@keyframes bookAnimation {
  0% {
    transform: translate(-50%, -45%);
  }

  50% {
    transform: translate(-50%, -55%);
  }

  100% {
    transform: translate(-50%, -45%);
  }
}

@media (max-width: 991px) {
  .book {
    min-width: 760px;
  }
  .dc-loading p {
    font-size: 30px;
    margin-top: 30px;
  }
}

@media (max-width: 768px) {
  .book {
    width: 90%;
    min-width: 500px;
  }

  .paper {
    min-width: calc(100% + 200px);
  }
  .dc-loading p {
    font-size: 24px;
    margin-top: 24px;
  }
}

@media (max-width: 510px) {
  .book {
    width: 95%;
    min-width: 95%;
  }
}

@media (max-height: 690px) {
  .logo {
    width: 50px !important;
  }
  .dc-loading p {
    font-size: 20px;
    margin-top: 14px;
  }
  .loading-bar {
    margin-bottom: 30px;
  }
  .book {
    height: 95%;
    width: auto;
    min-width: auto;
    transform: translate(-50%, -48%);
  }

  @keyframes bookAnimation {
    0% {
      transform: translate(-50%, -48%);
    }

    50% {
      transform: translate(-50%, -52%);
    }

    100% {
      transform: translate(-50%, -48%);
    }
  }
}
</style>
